import React, { useState, useEffect } from "react";
import { Form, Typography, Input, Space, Button, Radio, Switch, Select } from "antd";

import { SaveOutlined, UndoOutlined } from "@ant-design/icons";

//Importaciones para el uso de Redux
import { useDispatch } from "react-redux";
import { updateRolEnviromentAction } from "../../../../../actions/rolEnviromentActions";

//Styles
import curStyle from "../../../../../css/GlobalCmp.module.css";

//Importaciones Propias
import CST from "../../../../../utils/CustomSettings";
import { showNotification } from "../../../../../utils/ShowNotification";
import CRM from "../../../../../utils/CrmService";

export default function CjbCajasCuentasForm(props) {
  const { record, closeModal, sociedades, currentUser, varEffec } = props;
  const [form] = Form.useForm();
  const [curId, setCurId] = useState(record.cue_id);
  const [loadingButton, setLoadingButton] = useState(false);
  const [scd_id_val,setSociedades] = useState(record.cue_id > 0 ? record.scd_id : 0);
  const [activa, setActiva] = useState(record.cue_id > 0 ? record.cue_activa : 1);
  const [cueTipo, setCueTipo] = useState(record.cue_tipo);

  useEffect(() => {
    setCurId(record.cue_id);
  }, [varEffec]);

  //Ejecutar dispatch tras el logueo
  const dispatch = useDispatch();
  const updateEnviroment = (state) =>
    dispatch(updateRolEnviromentAction(state));

  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };

  const { Option } = Select;
  const { Title } = Typography;

  const guardarCambios = async (values) => {
    console.log(values);
    setLoadingButton(true);
    let val_record = await CRM.sendCjbCajasCuentas(
      currentUser,
      curId,
      activa,
      cueTipo,
      "CjbCajasCuentas",
      values
    );
    console.log(val_record);
    if (Number.parseInt(val_record.type) > 0) {
      updateEnviroment(val_record.datos.rol_entorno);
      showNotification(
        "topRight",
        4,
        "GESTION DE CAJAS Y CUENTAS BANCARIAS",
        "REGISTRO EXITOSO"
      );
    } else {
      showNotification(
        "topRight",
        2,
        "GESTION DE CAJAS Y CUENTAS BANCARIAS",
        val_record.message
      );
    }
    setLoadingButton(false);
    closeModal();
  };

  //Renderizacion del componente
  return (
    <Form
      {...layout}
      form={form}
      name="CjbCajasCuentas"
      onFinish={guardarCambios}
      initialValues={{
        scd_id:  record.cue_id > 0 ? record.scd_id : 0,
        cue_nombre: record.cue_id > 0 ? record.cue_nombre : "",
        cue_tipo: record.cue_id > 0 ? record.cue_tipo : "",
        cue_activa: record.cue_id > 0 ? record.cue_activa : "",
      }}
      scrollToFirstError
    >
      <Form.Item>
        <Title
          level={4}
          style={{
            padding: 2,
            margin: 2,
            fontWeight: 600,
            textAlign: "left",
            color: CST.colorSec,
          }}
        >
          {record.cue_id > 0
            ? "ACTUALIZAR CAJAS Y CUENTAS BANCARIAS"
            : "AGREGAR CAJAS Y CUENTAS BANCARIAS"}
        </Title>
      </Form.Item>
      <Form.Item
        name="scd_id"
        label="Sociedad"
        wrapperCol={{ span: 100 }}
        style={{ display: "flex", flexDirection: "row" }}
      >
          <Select
            showSearch
            showArrow
            style={{ width: "300px" }}
            defaultValue={scd_id_val}
            onChange={(val) => setSociedades(val)}
            placeholder="Sociedad"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {sociedades.map((socie) => (
              <Option key={socie.scd_id} value={socie.scd_id}>
                {socie.scd_nombre}
              </Option>
            ))}
          </Select>
      </Form.Item>
      <Form.Item
        name="cue_nombre"
        label="Nombre"
        rules={[
          {
            required: true,
            message: "El nombre es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase" }}
          value={record.cue_id > 0 ? record.cue_nombre : ""}
        />
      </Form.Item>
      <Form.Item
        name="cue_tipo"
        label="Tipo"
        rules={[
          {
            required: true,
            message: "El tipo es obligatorio",
          },
        ]}
      >
        <Radio.Group
          onChange={(option) => setCueTipo(option.target.value)}
          value={cueTipo}
        >
          <Radio value={1}>Efectivo</Radio>
          <Radio value={2}>Bancaria</Radio>
          <Radio value={3}>Cheques</Radio>
          <Radio value={4}>Retencion</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        name="cue_activa"
        label="Estado"
        rules={[
          {
            required: true,
            message: "El estado es obligatorio",
          },
        ]}
      >
        <Radio.Group
          onChange={(option) => setActiva(option.target.value)}
          value={activa}
          defaultValue={activa}
        >
          <Radio value={1}>Activa</Radio>
          <Radio value={2}>Inactiva</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 4 }}>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            className={curStyle.btnOrange}
            loading={loadingButton}
          >
            <SaveOutlined /> Guardar
          </Button>
          <Button
            type="primary"
            className={curStyle.btnInverse}
            onClick={() => closeModal()}
          >
            <UndoOutlined /> Cancelar
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
